import { ValueDisplayIcon } from '../../components/ValueDisplay'
import { graces, ISensorAnalog } from './types'
import { useGetMeasurmentColor } from '../../../hooks/useGetMeasurmentColor'
import { OperatorPanelWrapperFullSize } from '../../components/Layout';
import { useIntl } from 'react-intl';
import { TimeSeriesLineChart } from '../../../features/Charts/LineCharts/TimeSeriesLineChart';
import { useMemo } from 'react';
import { Notification } from "baseui/notification";
import { FormattedMessage } from 'react-intl';
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { themedUseStyletron } from '../../../theme/customTheme';

export const OperatorPanel = (props: ISensorAnalog) => {
    const intl = useIntl();
    const [color] = useGetMeasurmentColor(props.dimension);
    const [css, theme] = themedUseStyletron();
    const isNormalPercentSensor = props.schema === 'AutomationApps.Devices.Sensors.SensorAnalog' && props.dimension === '%';
    const myColor = isNormalPercentSensor ? theme.appColors.measurments.default : color;

    const [overridden] = useSetObjectValue(props.id, props.resourceGroupId, "overridden", props.overridden, 0);

    const hasValidHighLimit = props.enableAlarmLimitHigh && props.alarmLimitHigh !== undefined && props.alarmLimitHigh < Number.MAX_SAFE_INTEGER;
    const hasValidLowLimit = props.enableAlarmLimitLow && props.alarmLimitLow !== undefined && props.alarmLimitLow > Number.MIN_SAFE_INTEGER;

    var lines = useMemo<any>(() => {
        var lines = [{ yScaleId: 'y', fill: true, stepped: false, label: props.description, lineColor: myColor, objectId: props.id, resourceGroupId: props.resourceGroupId, propertyName: 'value', currentValue: props.value, grace: graces[props.dimension], dimension: props.dimension }];
        if (hasValidLowLimit) lines.push({ yScaleId: 'y', label: intl.formatMessage({ id: "AnalogSensor.AlarmLimitLow", defaultMessage: "Alarm limit MIN" }), fill: false, lineColor: theme.colors.negative600, objectId: props.id, resourceGroupId: props.resourceGroupId, propertyName: 'alarmLimitLow', stepped: true, currentValue: props.alarmLimitLow || 0, grace: graces[props.dimension] , dimension: props.dimension});
        if (hasValidHighLimit) lines.push({ yScaleId: 'y', label: intl.formatMessage({ id: "AnalogSensor.AlarmLimitHigh", defaultMessage: "Alarm limit MAX" }), fill: false, lineColor: theme.colors.negative500, objectId: props.id, resourceGroupId: props.resourceGroupId, propertyName: 'alarmLimitHigh', stepped: true, currentValue: props.alarmLimitHigh || 0, grace: graces[props.dimension], dimension: props.dimension });
        return lines;
    }, [hasValidLowLimit, hasValidHighLimit, props.value]);

    return (
        <OperatorPanelWrapperFullSize objectId={props.id} resourceGroupId={props.resourceGroupId}
            statusContent={<ValueDisplayIcon {...props} ></ValueDisplayIcon>}
            additionalContent={
                <div className={css({ minHeight: '300px', height: '600px', width: '100%' })}>
                    <TimeSeriesLineChart
                        showLegend={true}
                        timespan={3 * 24 * 60}
                        enableZoom
                        showMaxValue
                        showMinValue
                        showTimeNavigation
                        lines={lines}
                        summarizeBy={'1s'}
                        showAverage={true}></TimeSeriesLineChart>

                    {(overridden) && (< Notification>
                        <FormattedMessage id='Sensor.SensorOverride' defaultMessage="The sensor is being overridden by a mechanism local to the device" />
                    </Notification>)}

                </div>}>
        </OperatorPanelWrapperFullSize>
    )
}

